import { Component, EventEmitter, Input, Output } from '@angular/core';
import { STATUS_CONFIGS, StatusConfig, SubscriptionStatus } from './plans-status.constants';

@Component({
  selector: 'app-plans-status',
  templateUrl: './plans-status.component.html',
  styleUrls: ['./plans-status.component.scss']
})
export class PlansStatusComponent {
  @Input() status: SubscriptionStatus = SubscriptionStatus.REDIRECTING;
  @Input() isDialog: boolean = false;
  @Output() goBack = new EventEmitter<void>();

  readonly SubscriptionStatus = SubscriptionStatus;

  get config(): StatusConfig {
    return STATUS_CONFIGS[this.status];
  }

  onGoBack(): void {
    this.goBack.emit();
  }
}
